import type { TrackPayload } from '../../../shared/analyticsEvents.js'

import useLocalStorage from '@based/use-local-storage'
const SESSION_KEY = 'esc_analytics_session'

export const useSession = (): [
  TrackPayload['session'] | undefined,
  (session: any) => void,
] => {
  let session: TrackPayload['session'] | undefined = undefined
  const [sessionString, setSession] = useLocalStorage<string | undefined>(
    SESSION_KEY,
    undefined,
  )
  if (typeof sessionString === 'string') {
    try {
      session = JSON.parse(sessionString)
    } catch {
      console.warn('Session is not valid JSON')
    }
  }
  return [session, setSession]
}
